export enum enumCountryId {
    Turkiye = 1,
    Nederland = 2,
    Deutschland = 3,
    Belgie = 4,
    France = 5,
    England = 6
};
